import { notification } from 'antd';

import { i18n } from 'app/i18n-config';

export const handleError = (error: any) => {
  notification.error({
    message: i18n.t('common.errorOccurred'),
  });
};
